import {Breakpoints, paginationItemClasses, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiPagination = ({pagination}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => {
  return {
    MuiPagination: {
      styleOverrides: {
        root: {}
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          color: pagination?.page.desktop.font.color,
          fontSize: pagination?.page.desktop.font.size,
          fontWeight: pagination?.page.desktop.font.weight,
          lineHeight: pagination?.page.desktop.font.lineHeight,
          '&:hover': {
            opacity: 1,
            color: pagination?.page.desktop.hover.font.color,
            backgroundColor: pagination?.page.desktop.hover.background.color
          },
          [`&.${paginationItemClasses.focusVisible}`]: {
            opacity: 1,
            color: pagination?.page.desktop.hover.font.color,
            backgroundColor: pagination?.page.desktop.hover.background.color
          },
          [`&.${paginationItemClasses.selected}`]: {
            backgroundColor: pagination?.page.selected.desktop.hover.background.color,
            color: pagination?.page.selected.desktop.font.color,
            '&:hover': {
              backgroundColor: pagination?.page.selected.desktop.background.color
            },
            '&.Mui-focusVisible': {
              backgroundColor: pagination?.page.selected.desktop.background.color
            }
          },
          [`&.${paginationItemClasses.disabled}`]: {
            color: '#B1B2B4'
          },
          [mediaQueries.down('md')]: {
            fontSize: pagination?.page.mobile.font.size,
            fontWeight: pagination?.page.mobile.font.weight,
            lineHeight: pagination?.page.mobile.font.lineHeight
          }
        },
        ellipsis: {
          color: pagination?.elipsis.desktop.icon.color,
          '&:hover': {
            color: pagination?.elipsis.desktop.icon.color,
            backgroundColor: 'transparent'
          }
        },
        previousNext: {
          color: pagination?.links.desktop.font.color,
          '&:hover': {
            color: pagination?.links.desktop.font.color,
            backgroundColor: pagination?.page.desktop.hover.background.color
          },
          '&:active': {
            backgroundColor: pagination?.page.selected.desktop.hover.background.color,
            color: pagination?.page.selected.desktop.font.color
          }
        }
      }
    }
  };
};
